import React, { useEffect } from "react";
import { useState } from "react";
import { NonAuthRoutes } from "../../constants/Constants";
import { useNavigate } from "react-router-dom";
import ATextField from "../../components/ATextField";
import { Icon, PrimaryButton } from "@fluentui/react";
import { AuthenticateOTPSchema } from "../../Schemas/LoginSchema";
import { encryptData } from "../../helpers/RSAUtility";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import { authenticateOTP, generateOTP } from "../../service/UserService";
import VDC_AIPoweredCloudPacs from "../../components/SVGComponents/Logo/VDC_AIPoweredCloudPacs";

const textFieldStyles = {
  errorMessage: {
    color: "#ff0000",
    fontWeight: "700",
    fontSize: "12px",
  },
  fieldGroup: {
    borderRadius: "7px",
  },
  field: {
    ":focus": {
      borderRadius: "7px",
    },
  },
  root: {
    color: "rgb(255,255,255) !important",
    border: "none !important",
  },
};
const Otp = () => {
  const [email] = useState(
    localStorage.getItem("forgotPasswordEmail")
  );
  const [username, setUsername] = useState(
    localStorage.getItem("forgotPasswordUsername")
  );
  const [otp] = useState("");
  const navigate = useNavigate();
  const [t] = useTranslation();
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [resendEnablingTime, setResendEnablingTime] = useState(30);

  useEffect(() => {
    const forgotPasswordUsername = localStorage.getItem(
      "forgotPasswordUsername"
    );
    if (forgotPasswordUsername && forgotPasswordUsername != null) {
      setUsername(forgotPasswordUsername);
    } else {
      navigate(NonAuthRoutes.LOGIN);
    }
  }, []);

  const handleResend = async () => {
    const encryptedUsername = encryptData(
      localStorage.getItem("forgotPasswordUsername")
    );
    const response = await generateOTP(encryptedUsername);
    if (response.status === 200) {
      localStorage.setItem("forgotPasswordEmail", response.data.data.email);
      setResendEnablingTime(30);
      setIsResendEnabled(false);
    }
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        username,
        otp,
      },
      validationSchema: () => AuthenticateOTPSchema(t),
      onSubmit: async (values, action) => {
        const encryptedUsername = encryptData(values.username);
        const encryptedOTP = encryptData(values.otp);

        const response = await authenticateOTP(encryptedUsername, encryptedOTP);

        if (response.status === 200) {
          // localStorage.setItem("forgotPasswordUsername", values.username);
          localStorage.removeItem("forgotPasswordEmail");
          navigate(NonAuthRoutes.RESETPASSWORD);
        } else {
          setIsAuthenticated(false);
          if (
            !(
              response.data.message.includes("1") ||
              response.data.message.includes("2") ||
              response.data.message.includes("required")
            )
          ) {
            setResendEnablingTime(0);
            setIsResendEnabled(false);
          }
          setErrorMessage(response.data.message);
        }

        action.resetForm();
      },
    });

  useEffect(() => {
    if (!isResendEnabled) {
      setTimeout(() => {
        if (resendEnablingTime === 0) {
          setIsResendEnabled(true);
        } else {
          setResendEnablingTime(resendEnablingTime - 1);
        }
      }, 1000);
    }
  }, [resendEnablingTime, isResendEnabled]);

  return (
    <>
      <div
        className="ms-Grid container"
        dir="ltr"
        style={{
          height: "100%",
          width: "100%",
          padding: "0px",
          overflowY: "hidden",
          backgroundColor: "white"
        }}
      >
        <div className="ms-Grid-row" style={{ width: "100%", height: "100vh" }}>
          <div
            className="ms-Grid-col ms-xl6 ms-hiddenLgDown"
            style={{ padding: "0", height: "100%" }}
          >
            {process.env.REACT_APP_VDC_PLATFORM === "true" ? (
              <VDC_AIPoweredCloudPacs />
            ) : (
              <img
                className="ai-powered-cloud-image"
                src={`${window.location.origin}/images/AIPoweredCloudPacs.png`}
                alt="AI Powered Cloud Pacs"
              />
            )}
          </div>
          <div
            className="ms-Grid-col ms-sm12 ms-md10 ms-lg8 ms-xl4 ms-xlPush1 ms-lgPush2 ms-mdPush1"
            style={{ padding: "0" }}
          >
            <div className="login-form-container">
              <form>
                <p
                  className="ms-fontSize-12 ms-fontWeight-semibold"
                  style={{
                    marginBottom: "20px",
                    lineHeight: "16px",
                  }}
                >
                  An OTP has been sent to your registered email id -{" "}
                  <span style={{ fontWeight: "bold" }}>{email}</span>
                  <br></br>
                  <br></br>
                  In case you do not see the email in your inbox, please check
                  your spam or junk mail folder before requesting for a new OTP.
                </p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    margin: "30px 0 5px",
                    color: "#ff0000",
                  }}
                >
                  {!isAuthenticated && (
                    <div
                      className="ms-fontSize-1"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Icon
                        iconName="InfoSolid"
                        className="ms-fontSize-14"
                        style={{ marginRight: "5px" }}
                      ></Icon>
                      <p className="ms-fontSize-12 login-form-error-messages ms-fontWeight-bold">
                        {errorMessage}
                      </p>
                    </div>
                  )}
                </div>
                <div>
                  <ATextField
                    name="username"
                    label="Username"
                    onChange={handleChange}
                    value={values.username}
                    onBlur={handleBlur}
                    errorMessage={touched.username && errors.username}
                    styles={textFieldStyles}
                    disabled={true}
                  />
                  <ATextField
                    name="otp"
                    label="OTP"
                    onChange={handleChange}
                    value={values.otp}
                    onBlur={handleBlur}
                    errorMessage={touched.otp && errors.otp}
                    styles={textFieldStyles}
                  />
                </div>
                <div
                  style={{
                    marginTop: "30px",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <PrimaryButton
                    className="ms-fontSize-14"
                    text={t("button.reset-password")}
                    style={{ width: "150px" }}
                    onClick={handleSubmit}
                  />
                  <PrimaryButton
                    className="ms-fontSize-14"
                    text={t("button.resend-otp")}
                    style={{ width: "150px" }}
                    onClick={handleResend}
                    disabled={!isResendEnabled}
                  />
                </div>
                {!isResendEnabled && (
                  <div
                    style={{
                      marginTop: "5px",
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                    }}
                  >
                    <span style={{ fontSize: "13px" }}>
                      Resend OTP in {resendEnablingTime}s
                    </span>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Otp;
